import { css } from 'styled-components'

const createButtonTheme = (key: string, colorConfig: { [key: number]: string }) => {
  return css`
    .theme-${key} .c--btn {
      :not(.theme-ignore):not(.inverted) {
        --c-btn-primary-default-bg: ${colorConfig[3]};
        --c-btn-primary-default-text: ${({ theme }) => theme.colors.white[1]};
        --c-btn-primary-hover-bg: ${colorConfig[2]};
        --c-btn-primary-hover-text: ${({ theme }) => theme.colors.white[1]};
        --c-btn-primary-active-bg: ${colorConfig[5]};
        --c-btn-primary-active-text: ${({ theme }) => theme.colors.black[1]};
        --c-btn-primary-inactive-bg: transparent;
        --c-btn-primary-inactive-text: ${({ theme }) => theme.colors.black[3]};
        --c-btn-primary-disabled-bg: ${colorConfig[7]};
        --c-btn-primary-disabled-text: ${colorConfig[5]};

        --c-btn-secondary-default-bg: transparent;
        --c-btn-secondary-default-text: ${colorConfig[2]};
        --c-btn-secondary-default-border: ${colorConfig[6]};
        --c-btn-secondary-hover-bg: ${colorConfig[2]};
        --c-btn-secondary-hover-text: ${({ theme }) => theme.colors.white[1]};
        --c-btn-secondary-hover-border: transparent;
        --c-btn-secondary-active-bg: ${colorConfig[5]};
        --c-btn-secondary-active-text: ${({ theme }) => theme.colors.black[1]};
        --c-btn-secondary-active-border: transparent;
        --c-btn-secondary-inactive-bg: transparent;
        --c-btn-secondary-inactive-text: ${({ theme }) => theme.colors.black[3]};
        --c-btn-secondary-inactive-border: transparent;
        --c-btn-secondary-disabled-bg: transparent;
        --c-btn-secondary-disabled-text: ${colorConfig[5]};
        --c-btn-secondary-disabled-border: ${colorConfig[7]};

        --c-btn-tertiary-default-bg: transparent;
        --c-btn-tertiary-default-text: ${({ theme }) => theme.colors.black[1]};
        --c-btn-tertiary-hover-bg: ${colorConfig[2]};
        --c-btn-tertiary-hover-text: ${({ theme }) => theme.colors.white[1]};
        --c-btn-tertiary-active-bg: ${colorConfig[5]};
        --c-btn-tertiary-active-text: ${({ theme }) => theme.colors.black[1]};
        --c-btn-tertiary-inactive-bg: transparent;
        --c-btn-tertiary-inactive-text: ${({ theme }) => theme.colors.black[3]};
        --c-btn-tertiary-disabled-bg: transparent;
        --c-btn-tertiary-disabled-text: ${({ theme }) => theme.colors.black[4]};
      }

      &:not(.theme-ignore).inverted {
        --c-btn-primary-default-text: ${colorConfig[1]};
        --c-btn-primary-hover-text: ${colorConfig[1]};
        --c-btn-primary-active-text: ${colorConfig[1]};

        --c-btn-secondary-hover-text: ${colorConfig[1]};
        --c-btn-secondary-active-text: ${colorConfig[1]};

        --c-btn-tertiary-hover-text: ${colorConfig[1]};
        --c-btn-tertiary-active-text: ${colorConfig[1]};
      }
    }
  `
}

export const ButtonTheme = css`
  .c--btn {
    // primary default styles
    --c-btn-primary-default-bg: ${({ theme }) => theme.colors.black[2]};
    --c-btn-primary-default-text: ${({ theme }) => theme.colors.white[1]};
    --c-btn-primary-hover-bg: ${({ theme }) => theme.colors.black[1]};
    --c-btn-primary-hover-text: ${({ theme }) => theme.colors.white[1]};
    --c-btn-primary-active-bg: ${({ theme }) => theme.colors.black[6]};
    --c-btn-primary-active-text: ${({ theme }) => theme.colors.black[1]};
    --c-btn-primary-inactive-bg: transparent;
    --c-btn-primary-inactive-text: ${({ theme }) => theme.colors.black[3]};
    --c-btn-primary-disabled-bg: ${({ theme }) => theme.colors.black[7]};
    --c-btn-primary-disabled-text: ${({ theme }) => theme.colors.black[4]};

    // secondary default styles
    --c-btn-secondary-default-bg: transparent;
    --c-btn-secondary-default-text: ${({ theme }) => theme.colors.black[1]};
    --c-btn-secondary-default-border: ${({ theme }) => theme.colors.black[6]};
    --c-btn-secondary-hover-bg: ${({ theme }) => theme.colors.black[1]};
    --c-btn-secondary-hover-text: ${({ theme }) => theme.colors.white[1]};
    --c-btn-secondary-hover-border: transparent;
    --c-btn-secondary-active-bg: ${({ theme }) => theme.colors.black[6]};
    --c-btn-secondary-active-text: ${({ theme }) => theme.colors.black[1]};
    --c-btn-secondary-active-border: transparent;
    --c-btn-secondary-inactive-bg: transparent;
    --c-btn-secondary-inactive-text: ${({ theme }) => theme.colors.black[3]};
    --c-btn-secondary-inactive-border: transparent;
    --c-btn-secondary-disabled-bg: transparent;
    --c-btn-secondary-disabled-text: ${({ theme }) => theme.colors.black[4]};
    --c-btn-secondary-disabled-border: ${({ theme }) => theme.colors.black[7]};

    // tertiary default styles
    --c-btn-tertiary-default-bg: transparent;
    --c-btn-tertiary-default-text: ${({ theme }) => theme.colors.black[1]};
    --c-btn-tertiary-hover-bg: ${({ theme }) => theme.colors.black[1]};
    --c-btn-tertiary-hover-text: ${({ theme }) => theme.colors.white[1]};
    --c-btn-tertiary-active-bg: ${({ theme }) => theme.colors.black[6]};
    --c-btn-tertiary-active-text: ${({ theme }) => theme.colors.black[1]};
    --c-btn-tertiary-inactive-bg: transparent;
    --c-btn-tertiary-inactive-text: ${({ theme }) => theme.colors.black[3]};
    --c-btn-tertiary-disabled-bg: transparent;
    --c-btn-tertiary-disabled-text: ${({ theme }) => theme.colors.black[4]};

    .inverted,
    &:not(.theme-ignore).inverted {
      --c-btn-primary-default-bg: ${({ theme }) => theme.colors.white[1]};
      --c-btn-primary-default-text: ${({ theme }) => theme.colors.black[2]};
      --c-btn-primary-hover-bg: ${({ theme }) => theme.colors.white[1]};
      --c-btn-primary-hover-text: ${({ theme }) => theme.colors.black[2]};
      --c-btn-primary-active-bg: ${({ theme }) => theme.colors.white[2]};
      --c-btn-primary-active-text: ${({ theme }) => theme.colors.black[1]};
      --c-btn-primary-inactive-bg: transparent;
      --c-btn-primary-inactive-text: ${({ theme }) => theme.colors.white[3]};
      --c-btn-primary-disabled-bg: ${({ theme }) => theme.colors.white[6]};
      --c-btn-primary-disabled-text: ${({ theme }) => theme.colors.white[4]};

      --c-btn-secondary-default-bg: transparent;
      --c-btn-secondary-default-text: ${({ theme }) => theme.colors.white[1]};
      --c-btn-secondary-default-border: ${({ theme }) => theme.colors.white[2]};
      --c-btn-secondary-hover-bg: ${({ theme }) => theme.colors.white[1]};
      --c-btn-secondary-hover-text: ${({ theme }) => theme.colors.black[2]};
      --c-btn-secondary-hover-border: transparent;
      --c-btn-secondary-active-bg: ${({ theme }) => theme.colors.white[2]};
      --c-btn-secondary-active-text: ${({ theme }) => theme.colors.black[1]};
      --c-btn-secondary-active-border: transparent;
      --c-btn-secondary-inactive-bg: transparent;
      --c-btn-secondary-inactive-text: ${({ theme }) => theme.colors.white[3]};
      --c-btn-secondary-inactive-border: transparent;
      --c-btn-secondary-disabled-bg: transparent;
      --c-btn-secondary-disabled-text: ${({ theme }) => theme.colors.white[4]};
      --c-btn-secondary-disabled-border: ${({ theme }) => theme.colors.white[6]};

      --c-btn-tertiary-default-bg: transparent;
      --c-btn-tertiary-default-text: ${({ theme }) => theme.colors.white[1]};
      --c-btn-tertiary-hover-bg: ${({ theme }) => theme.colors.white[1]};
      --c-btn-tertiary-hover-text: ${({ theme }) => theme.colors.black[2]};
      --c-btn-tertiary-active-bg: ${({ theme }) => theme.colors.white[2]};
      --c-btn-tertiary-active-text: ${({ theme }) => theme.colors.black[1]};
      --c-btn-tertiary-inactive-bg: transparent;
      --c-btn-tertiary-inactive-text: ${({ theme }) => theme.colors.white[3]};
      --c-btn-tertiary-disabled-bg: transparent;
      --c-btn-tertiary-disabled-text: ${({ theme }) => theme.colors.white[4]};
    }
  }

  ${({ theme }) => createButtonTheme('electric-indigo', theme.colors.electricIndigo)}
  ${({ theme }) => createButtonTheme('limegreen', theme.colors.limegreen)}
  ${({ theme }) => createButtonTheme('bluetiful', theme.colors.bluetiful)}
  ${({ theme }) => createButtonTheme('red', theme.colors.red)}
  ${({ theme }) => createButtonTheme('orange', theme.colors.orange)}
  ${({ theme }) => createButtonTheme('yellow', theme.colors.yellow)}
  ${({ theme }) => createButtonTheme('turquoise', theme.colors.turquoise)}
  ${({ theme }) => createButtonTheme('fuchsia', theme.colors.fuchsia)}
  ${({ theme }) => createButtonTheme('magenta', theme.colors.magenta)}
  ${({ theme }) => createButtonTheme('azure', theme.colors.azure)}
`
